export default __webpack_public_path__ + "static/media/solana-icon.2dc78b21.svg";